/** @jsx jsx */
import { jsx, Text } from "theme-ui";

import { ActionButton } from "office-ui-fabric-react";

import LanguageSelector, { useLang } from "./LanguageSelector";

const P0Header = () => {
  const [getLangString] = useLang();

  return (
    <div>
      <div sx={{ textAlign: "center", m: 2 }}>
        <Text variant="header">{getLangString("strings.note1")}</Text>
        <br />
        <Text variant="subheader">{getLangString("strings.note2")}</Text>
        <br />
        <Text variant="subtitle">
          {getLangString("strings.note3")}
          <ActionButton
            iconProps={{ iconName: "SurveyQuestions" }}
            target="_blank"
            href="https://cdn-prod.heartfulness.org/images/overseas/GUIDELINES_FOR_OVERSEAS_VISITORS.pdf"
            rel="noreferrer"
          />
        </Text>
        <br />
        <LanguageSelector />

        <hr />
      </div>
    </div>
  );
};

export default P0Header;
